import type { Row } from '@tanstack/react-table';
import type { DateTime } from 'luxon';

type DateTimeKeys<T> = {
  [K in keyof T]: T[K] extends DateTime | undefined ? K : never;
}[keyof T];

export function dateTimeSortingFn<T>(rowA: Row<T>, rowB: Row<T>, key: DateTimeKeys<T>) {
  const c1 = (rowA?.original[key] as DateTime | undefined)?.toMillis?.() ?? 0;
  const c2 = (rowB?.original[key] as DateTime | undefined)?.toMillis?.() ?? 0;
  return c1 - c2;
}
